import { Component, OnDestroy, ViewChild, OnInit } from "@angular/core";
import { _i18n_str } from "../../assets/i18n/non-static-ids";
import {
  EventLoggingService,
  LogEventId,
  ILogEvent
} from "../../app/services/event-logging.service";
import { NavController, NavParams, Events } from "ionic-angular";
import { FhirService } from "../../app/services/fhir.service";
import { TranslateService } from "@ngx-translate/core";
import { AdminService } from "../../app/services/admin.service";
import { DiaprofilPatient } from "../../app/models/diaprofil-patient";
import { IDiaprofilHcp } from "../../app/models/types";

@Component({
  selector: "log-event-listing-page",
  templateUrl: "log-event-listing.page.html"
})
export class LogEventListingPage implements OnInit, OnDestroy {
  @ViewChild("logEventListing") table: any;
  logEvents: ILogEvent[] = [];
  localizedTableMessages: { [key: string]: string };
  patient: DiaprofilPatient = null;
  hcp: IDiaprofilHcp = null;
  startFrom = 0;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public events: Events,
    public fhir: FhirService,
    public translate: TranslateService,
    public admin: AdminService,
    private eventLogging: EventLoggingService
  ) {
    this.localizedTableMessages = {
      // Message to show when array is presented
      // but contains no values
      emptyMessage: translate.instant(
        _i18n_str("EVENT_LISTING.MESSAGES.NO_DATA_TO_DISPLAY")
      ),
      // Footer total message
      totalMessage: translate.instant(_i18n_str("EVENT_LISTING.MESSAGES.TOTAL"))
    };
  }

  ngOnInit() {
    this.patient = this.navParams.get("patient") || null;
    this.hcp = this.navParams.get("hcp") || null;
    this.initialLoad();
  }

  getHeader() {
    if (this.patient !== null) {
      if (this.hcp !== null) {
        return `Log oversigt for bruger '${this.hcp.hcpInitials}' ift. patient: '${this.patient.socialSecurityNumber} - ${this.patient.fullName}'`;
      } else {
        return `Log oversigt ift. patient: '${this.patient.socialSecurityNumber} - ${this.patient.fullName}'`;
      }
    } else {
      return `Log oversigt for bruger '${this.hcp.hcpInitials}'`;
    }
  }

  initialLoad() {
    this.startFrom = 0;
    this.eventLogging
      .getEvents({
        patient_fhir_id:
          this.patient !== null ? this.patient.fhirId : undefined,
        acting_user_login_id: this.hcp !== null ? this.hcp.userName : undefined,
        start_from: this.startFrom.toString(),
        result_size: "100"
      })
      .subscribe(result => {
        this.logEvents = [...result];
        console.log(this.logEvents);
      });
  }

  loadMore() {
    this.startFrom += 100;
    this.eventLogging
      .getEvents({
        patient_fhir_id:
          this.patient !== null ? this.patient.fhirId : undefined,
        acting_user_login_id: this.hcp !== null ? this.hcp.userName : undefined,
        start_from: this.startFrom.toString(),
        result_size: "100"
      })
      .subscribe(result => (this.logEvents = [...this.logEvents, ...result]));
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// ./src/pages/log-event-listing.page/log-event-listing.page.ts